<template>
  <div class="regardsWrap">
    <img src="./imgs/about_bg.png" width="100%" height="500" alt="">
    <div class="about_content">
      <div class="about_inner">
        <div class="text_wrap">
          <p class="about_title" >公司简介</p>
          <p ><span class="text_left" > </span>深圳市鑫安智能科技有限公司成立于2012年10月，位于深圳市宝安区，是一家专注于物联网技术、大数据技术、人工智能技术研发，聚焦智能物联领域和智慧环保领域的高新技术企业。公司拥有行业领先的整体解决方案，包括智慧环保大气监测软硬件产品定制开发方案，环境空气质量监测系统解决方案，恶臭监测解决方案，扬尘监测解决方案，温室气体监测解决方案等，智能化大气监测硬件产品覆盖固定式安装、车载式安装、便携式、无人机机载式安装等多个应用场景，融合了传感器技术、音视频技术、AI人工智能识别技术、智能算法技术，配合基于SaaS架构的信息化智慧环保平台、公众号、小程序，形成了整套端到端的智慧环保整体解决方案。</p><br/>
          <p ><span class="text_left" ></span>公司正在努力成为智能物联和智慧环保大气监测领域国内领先的整体解决方案提供商和运营服务商。</p><br/>
        </div>
        <div class="about_building">
          <img class="building" src="./imgs/building.png" alt="">
        </div>

        <div>
          <p class="about_title" >地图位置</p>
          <div class="about_map_wrap">
            <img src="./imgs/map.png" height="100%" width="100%" alt="">
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

  export default {
    data(){
      return{
        infos:"",
        timing:"",
        sponsors:'',
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .regardsWrap
    width 100%
    background-color #F1F1F1
    .about_content
      position relative
      width 1200px
      margin 0 auto
      .about_inner
        background: white
        margin-top -55px
        .about_building
          text-align center
          margin 25px 0
          .building
            width 600px
        .text_wrap
          width: 800px;margin: 0 auto;line-height: 28px;
          .text_left
            display: inline-block;margin-left: 30px;
      .about_title
        font-size: 20px;line-height: 60px;text-align: center;width: 100%;font-weight: bold;color #3E85F1
      .about_map_wrap
        width: 800px;height:520px;margin: 0px auto;padding-bottom: 50px;
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue